module.exports = __webpack_public_path__ + "0ad32cf06082fd404e24a54e94e94275.pdf";